export default __webpack_public_path__ + "static/media/sweet3.39a58c80.jpg";